import { render, staticRenderFns } from "./Contribute.vue?vue&type=template&id=ed99a304&scoped=true&"
import script from "./Contribute.vue?vue&type=script&lang=js&"
export * from "./Contribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed99a304",
  null
  
)

export default component.exports